import * as yup from 'yup';

export const transactionSchema = yup.object({
  description: yup
    .string()
    .required('Por favor, preencha o campo acima')
    .max(256, 'Número de caracteres permitidos é de 256'),
  value: yup.number().required('Preencha o campo acima'),
});
